import { Request } from "@/models";
import axios from "axios";

export default class RequestService {

    public async GetRequests(): Promise<Request[]> {
        const requests = (await axios.get(`requests`)).data;
        return requests;
    }

    public async GetRequest(id: number): Promise<Request | null> {
        const request = (await axios.get(`requests/${id}`)).data;
        return request;
    }
}
